import { formatDate } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
import { BeneficiaryType, BeneficiaryTypeNo, ErrorMessage } from 'src/app/core/constants/enum';
import { Errors, validationType } from 'src/app/core/model/error.model';
import { BeneficiaryService } from 'src/app/services/beneficiary/beneficiary.service';
import { OopsModalComponent } from '../oops-modal/oops-modal.component';
import { Router } from '@angular/router';
import { nonkycModelComponent } from '../non-kyc-modal/non-kyc-model.component';
import { OfflinepopupComponent } from '../offline-popup/offline-popup.component'
import { InvestmentService } from 'src/app/services/investment/investment.service';
import { ApplicationService } from 'src/app/services/application/application.service';
import { OTPValidationModal } from '../otpValidationModel/otp-validation-modal.component';
import { CommonService } from 'src/app/services/common/common.service';
import { Holder } from 'src/app/core/model/holder.model';
import { HolderService } from 'src/app/services/holder/holder.service';
import { dailogModal } from '../dailog-Modal/dailog-modal';
import { CkycOkayModel } from '../okay-modal/okay-modal';

@Component({
  selector: 'app-add-beneficiary',
  templateUrl: './add-beneficiary.component.html',
  styleUrls: ['./add-beneficiary.component.scss'],
})
export class AddBeneficiaryComponent implements OnInit {
  beneficiaryForm: FormGroup;
  error = Errors;
  todayDate = new Date();
  holder: any
  showLoader: boolean = false;
  requestID: string = '';
  headerText = 'Check CKYC';
  messageText = 'Please wait, Verifying CKYC';
  @Input() application: any;
  @Input() beneficiaryType: string;
  BeneficiaryType = BeneficiaryType
  showSubmitButton: boolean = true;
  ckycSearchData: string = ""
  panFixed: boolean = false;
  dobFixed: boolean = false;
  checkPan: boolean = false;
  constructor(
    private modalController: ModalController,
    private readonly beneficiaryService: BeneficiaryService,
    private toastController: ToastController,
    private router: Router,
    private readonly applicationService: ApplicationService,
    private investmentService: InvestmentService,
    private readonly commonService: CommonService,
    private holderService: HolderService
  ) { }

  ngOnInit() {
    this.createForm();
    this.panListerner();
    if (this.application && this.application.beneficiaryType === this.BeneficiaryType.Director_Promoter) {
      this.form.relationship.setValidators(validationType.Required);
      this.form.relationship.updateValueAndValidity();
    }
  }

  get form() {
    return this.beneficiaryForm.controls;
  }

  createForm() {
    const CKYCMobileNo = /^[6-9]\d{9}$/;
    this.beneficiaryForm = new FormGroup({
      pan: new FormControl('', validationType.PAN),
      dob: new FormControl('', Validators.required),
      relationship: new FormControl('', Validators.required),
      CKYCMobileNo: new FormControl('', [Validators.pattern(CKYCMobileNo)]),
    });
  }

  panListerner() {
    this.form.pan.valueChanges.subscribe((data) => {
      if (data) {
        let pan = this.form.pan.value;
        for (const iterator of this.application.holdersList) {
          if (iterator.pan === pan) {
            this.form.pan.setErrors({ duplicate: true });
            break;
          }
        }

        for (const iterator of this.application.nomineeList) {
          if (iterator.pan === pan) {
            this.form.pan.setErrors({ duplicate: true });
            break;
          }
        }
        for (const iterator of this.application.beneficiaryList) {
          if (iterator.pan === pan) {
            this.form.pan.setErrors({ duplicate: true });
            break;
          }
        }
      }
    });
  }


  async offlineModelView(message, isIndividual) {
    this.dismissModal();
    const modal = await this.modalController.create({
      component: OfflinepopupComponent,
      backdropDismiss: false,
      cssClass: 'my-custom-class',
      componentProps: {
        errorMessage: message,
        isIndividual: isIndividual
      }
    });
    await modal.present();
    await modal.onDidDismiss().then((event) => { });
  }

  async submit() {


    if (this.beneficiaryType !== BeneficiaryType.Director_Promoter) {
      this.form.relationship.setValidators(null);
      this.form.relationship.updateValueAndValidity();
    }
    if (this.beneficiaryForm.invalid) return;


    if (this.form.relationship.value === BeneficiaryType.Director || this.beneficiaryType === BeneficiaryType.Karta) {
      if (this.form.pan.value.charAt(3).toUpperCase() !== 'P') {
        this.offlineModelView(ErrorMessage.IndividualError, true)
        return;
      }
    }

    let dob = "";
    if (this.form.dob.value !== "") {
      let newDate = new Date(this.form.dob.value);
      newDate.setDate(newDate.getDate())
      let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
      dob = formatedDate;
    }

    let data = {
      applicationUuid: this.application.investmentID,
      pan: this.form.pan.value,
      dob: dob,
      typeOfInvestor: this.form.pan.value.charAt(3).toUpperCase() !== 'P' ? "Non-Individual" : "Individual",
      type: this.beneficiaryType,
      relationship: this.form.relationship.value !== '' ? this.form.relationship.value : this.beneficiaryType,
      ckycStatus: null,
      ckycDetail: null,
    };
    if (this.form.relationship.value) {
      data.type = this.form.relationship.value
    }
    this.showLoader = true;

    var reqBody;
    reqBody = {
      PAN: this.form.pan.value,
      DOB: dob
    }

    console.log(reqBody);
    console.log('Before ckyc call');
    this.applicationService.getCKYCForNonIndi(reqBody).subscribe(
      async (res: any) => {
        console.log('CKYC Response', res);
        this.showLoader = false;
        var datares = res.value;

        if (res.code == 400) {
          var ckycDetail = {
            "PAN": this.form.pan.value,
            "DateOfBirth": dob
          }

          data.ckycStatus = "error";
          data.ckycDetail = JSON.stringify(ckycDetail);
        }
        else {

          // datares.success ="ERROR";
          if (datares.status == "ERROR") {
            data.ckycStatus = "error";
            data.ckycDetail = JSON.stringify(ckycDetail);
          }
          else {
            data.ckycStatus = "SUCCESS";
            data.ckycDetail = JSON.stringify(res.value.data);
          }

        }

        console.log('Request Before creation call', data);
        this.beneficiaryService.createBeneficiary(data).subscribe(
          async (res: any) => {

            if (res.success == true) {


              let data = JSON.parse(res.data)
              if (data.ckycCheck === 1) {
                await this.modalController.dismiss({
                  data: data.investorId,
                });
                this.showLoader = false;
              }
              else {
                this.dismissModal();

                if (this.form.pan.value.charAt(3).toUpperCase() !== 'P') {
                  console.log("this.form.pan.value.charAt(3).toUpperCase()")
                  this.investmentService.deleteInvestment(this.application.investmentID, data.investorId, false, true, BeneficiaryTypeNo.Beneficiary).subscribe(
                    (res: any) => {

                      this.offlineModelView(ErrorMessage.NonKYCError, false)
                    },
                    (err) => {
                    }
                  );
                  return;
                }
                else {
                  data.investmentId = this.application.investmentID;
                  const modal = await this.modalController.create({
                    component: nonkycModelComponent,
                    backdropDismiss: false,
                    cssClass: 'my-custom-class',
                    componentProps: {
                      holder: data,
                      onPanCheck: false,
                      isBeneficiary: true,
                      BeneficiaryTypeNo: 4
                    }
                  });
                  await modal.present();
                  modal.onDidDismiss().then((event) => { });
                  return;
                }
              }

              // const toast = await this.toastController.create({
              //   message: res.message,
              //   duration: 2000,
              // });
              // toast.present();

            }
            else {
              this.dismissModal();
              const modal = await this.modalController.create({
                component: OopsModalComponent,
                backdropDismiss: false,
                cssClass: 'my-custom-class',
              });
              await modal.present();
              modal.onDidDismiss().then((event) => { });

              this.showLoader = false;
              const toast = await this.toastController.create({
                message: res.message,
                duration: 2000,
              });
              toast.present();
            }
          },
          async (err) => {
            this.showLoader = false;
            const toast = await this.toastController.create({
              message: err.error.message,
              duration: 2000,
            });
            toast.present();
          }
        );



      });



    // this.beneficiaryService.createBeneficiary(data).subscribe(
    //   async (res: any) => {
    //     this.showLoader = false;
    //     if (res.success == true) {

    //       let data = JSON.parse(res.data)
    //       if (data.ckycCheck === 1) {
    //         await this.modalController.dismiss({
    //           data: data.investorId,
    //         });
    //         this.showLoader = false;
    //       }
    //       else {
    //         this.dismissModal();

    //         if (this.form.pan.value.charAt(3).toUpperCase() !== 'P') {
    //           this.investmentService.deleteInvestment(this.application.investmentID, data.investorId, false, true, BeneficiaryTypeNo.Beneficiary).subscribe(
    //             (res: any) => {
    //               this.offlineModelView(ErrorMessage.NonKYCError, false)
    //             },
    //             (err) => {
    //             }
    //           );
    //           return;
    //         }
    //         else {
    //           const modal = await this.modalController.create({
    //             component: nonkycModelComponent,
    //             backdropDismiss: false,
    //             cssClass: 'my-custom-class',
    //             componentProps: {
    //               holder: data,
    //               onPanCheck: false,
    //               isBeneficiary: true,
    //               BeneficiaryTypeNo: 4
    //             }
    //           });
    //           await modal.present();
    //           modal.onDidDismiss().then((event) => { });
    //           return;
    //         }
    //       }

    //       // const toast = await this.toastController.create({
    //       //   message: res.message,
    //       //   duration: 2000,
    //       // });
    //       // toast.present();

    //     }
    //     else {
    //       this.dismissModal();
    //       const modal = await this.modalController.create({
    //         component: OopsModalComponent,
    //         backdropDismiss: false,
    //         cssClass: 'my-custom-class',
    //       });
    //       await modal.present();
    //       modal.onDidDismiss().then((event) => { });

    //       this.showLoader = false;
    //       const toast = await this.toastController.create({
    //         message: res.message,
    //         duration: 2000,
    //       });
    //       toast.present();
    //     }
    //   },
    //   async (err) => {
    //     this.showLoader = false;
    //     const toast = await this.toastController.create({
    //       message: err.error.message,
    //       duration: 2000,
    //     });
    //     toast.present();
    //   }
    // );

    // this.beneficiaryServ
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  onSubmitCKYC() {

    if (this.beneficiaryType !== BeneficiaryType.Director_Promoter) {
      this.form.relationship.setValidators(null);
      this.form.relationship.updateValueAndValidity();
    }
    if (this.beneficiaryForm.invalid) return;


    if (this.form.pan.value.charAt(3).toUpperCase() !== 'P') {
      this.submit()
      return
    }

    this.showLoader = true;
    const PAN = this.form.pan.value
    const DOB = this.form.dob.value

    const payload = {
      PAN: PAN,
      DOB: DOB
    }

    this.applicationService.CKYCSearchAPI(payload).subscribe({
      next: (CkysRes: any) => {
        const CkycData = CkysRes?.data ?? null;
        if (CkycData !== null) {
          this.ckycSearchData = CkycData;
        } else {
          this.ckycSearchData = null
        }

        let formatedDate = formatDate(this.form.dob.value, 'dd-MM-yyyy', 'en');
        const KRApayload = {
          PAN: PAN,
          DOB: formatedDate
        }

        this.applicationService.KRASearchAPI(KRApayload).subscribe({
          next: async (KRARes: any) => {

            if (KRARes.message.includes("PAN is not active or not found in KRA") || KRARes.message.includes("Some Error Occured")) {

              this.showLoader = false;

              const modal = await this.modalController.create({
                component: dailogModal,
                backdropDismiss: false,
                cssClass: 'my-custom-class',
                componentProps: {
                  pan: PAN,
                  ckycNo: this.ckycSearchData,
                  onReturn: async () => {
                    this.showLoader = true;
                    this.continueWithoutOTP()
                  }
                }
              });
              await modal.present();

            } else {
              this.applicationService.KRADownloadAPI(KRApayload).subscribe({
                next: async (KRADownloadRes: any) => {
                  if (KRADownloadRes.message.includes("PAN is not active or not found in KRA")) {
                    this.applicationService.getInvestorDetailsforCKYC(PAN).subscribe(
                      async (investorRes: any) => {
                        const investorArray = investorRes || [];

                        if (investorArray.length === 0) {
                          this.showLoader = false;
                          if (this.ckycSearchData == null) {
                            const modal = await this.modalController.create({
                              component: dailogModal,
                              backdropDismiss: false,
                              cssClass: 'my-custom-class',
                              componentProps: {
                                pan: PAN,
                                ckycNo: this.ckycSearchData,
                                onReturn: async () => {
                                  this.showLoader = true;
                                  this.continueWithoutOTP()
                                }
                              }
                            });
                            await modal.present();
                          } else {
                            const modal = await this.modalController.create({
                              component: CkycOkayModel,
                              backdropDismiss: false,
                              cssClass: 'my-custom-class',
                              componentProps: {
                                onReturn: async () => {
                                  this.dismissModal();
                                  this.showSubmitButton = false;
                                  this.panFixed = true;
                                  this.dobFixed = true
                                }
                              }
                            });
                            await modal.present();
                          }
                        } else {
                          const investor = investorArray[0];
                          const spiltName = (fullName: string = '') => {
                            if (fullName === null) {
                              return {
                                firstName: "",
                                middleName: "",
                                lastName: " ",
                              }
                            }
                            const parts = fullName.trim().split(/\s+/);
                            return {
                              firstName: parts[0] || '',
                              middleName: parts.length === 3 ? parts[1] : '',
                              lastName: parts.length >= 2 ? parts[parts.length - 1] : ''
                            };
                          }

                          const nameParts = spiltName(investor.investorName)
                          const fatherNameParts = spiltName(investor.fatherName)
                          const motherNameParts = spiltName(investor.motherFirstName)

                          let dob = "";
                          if (this.form.dob.value !== "") {
                            let newDate = new Date(this.form.dob.value);
                            newDate.setDate(newDate.getDate())
                            let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
                            dob = formatedDate;
                          }

                          let ckycNumberdata = ""

                          if (this.ckycSearchData !== null) {
                            ckycNumberdata = this.ckycSearchData
                          } else {
                            ckycNumberdata = ""
                          }

                          let data = {
                            applicationUuid: this.application.investmentID || null,
                            pan: this.form.pan.value || null,
                            dob: dob || null,
                            typeOfInvestor: this.form.pan.value.charAt(3).toUpperCase() !== 'P' ? "Non-Individual" : "Individual",
                            type: this.beneficiaryType || null,
                            relationship: this.form.relationship.value !== '' ? this.form.relationship.value : this.beneficiaryType || null,
                            ckycStatus: "error",
                            ckycDetail: '',
                            mobileNo: this.form.CKYCMobileNo.value || null,
                            ckycNumber: ckycNumberdata || null,
                            firstName: nameParts.firstName || null,
                            middleName: nameParts.middleName || null,
                            lastName: nameParts.lastName || null,
                            email: investor.email || null,
                            FatherName: fatherNameParts.firstName || null,
                            FatherMiddleName: fatherNameParts.middleName || null,
                            FatherLastName: fatherNameParts.lastName || null,
                            MotherFirstName: motherNameParts.firstName || null,
                            MotherMiddleName: motherNameParts.middleName || null,
                            MotherLastName: motherNameParts.lastName || null,
                            mobile: investor.mobile || null,
                            address: investor.address || null,
                            city: investor.city || null,
                            state: investor.state || null,
                            country: investor.country || null,
                            pincode: investor.pincode || null
                          };

                          if (this.form.relationship.value) {
                            data.type = this.form.relationship.value
                          }

                          this.beneficiaryService.createBeneficiary(data).subscribe({
                            next: (res: any) => {
                              let data = JSON.parse(res.data)
                              this.otpVerified(res);
                            },
                            error: (err) => {
                              console.log('checkCKYCAndSaveApplication error', err)
                              this.showLoader = false
                            }
                          })
                        }
                      },
                      async (err) => {
                        console.log('getInvestorDetailsforCKYC error', err)
                        this.showLoader = false
                      }
                    )
                  }
                  else {
                    let ckycNumberdata = ""

                    if (this.ckycSearchData !== null) {
                      ckycNumberdata = this.ckycSearchData
                    } else {
                      ckycNumberdata = ""
                    }

                    let data = {
                      applicationUuid: this.application.investmentID || null,
                      pan: this.form.pan.value || null,
                      dob: formatedDate || null,
                      typeOfInvestor: this.form.pan.value.charAt(3).toUpperCase() !== 'P' ? "Non-Individual" : "Individual",
                      type: this.beneficiaryType || null,
                      relationship: this.form.relationship.value !== '' ? this.form.relationship.value : this.beneficiaryType || null,
                      ckycStatus: "error",
                      ckycDetail: '',
                      mobileNo: this.form.CKYCMobileNo.value || null,
                      ckycNumber: ckycNumberdata || null,
                      KRA: JSON.stringify(KRADownloadRes),
                    };

                    if (this.form.relationship.value) {
                      data.type = this.form.relationship.value
                    }

                    this.beneficiaryService.createBeneficiary(data).subscribe({
                      next: (res: any) => {
                        let data = JSON.parse(res.data)
                        this.otpVerified(res);
                      },
                      error: (err) => {
                        console.log('checkCKYCAndSaveApplication error', err)
                        this.showLoader = false
                      }
                    })
                  }
                }
              });
            }
          }
        });

      },
      error: (err) => {
        console.error('CKYC search Api error', err)
      }
    });
  }

  otpVerified(res: any) {

    this.holder = res;
    // let holderData = JSON.parse(this.holder.data)
    let holderData: any;
    if (this.holder.data === undefined)
      holderData = this.holder
    else
      holderData = JSON.parse(this.holder.data)

    let body = {} as Holder;
    body.otpTriggered = true;
    body.uuid = holderData.investorId;

    this.holderService.updateHolderOTP(body).subscribe(
      (res) => {
        setTimeout(() => {
          this.modalController.dismiss();

          this.commonService.encrypt(holderData.investorId).subscribe((res: any) => {

            let investorId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');

            this.commonService.encrypt(this.application.investmentID).subscribe((res: any) => {

              let investmentId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');

              window.location.href = '/application/beneficiary/' + investorId + "/" + investmentId;

            });

          });



          // this.router.navigateByUrl(
          //   '/application/applicant-kyc-details/' + holderData.investorId + "/" + holderData.investmentId
          // );
        }, 3000);
      },
      (err) => { }
    );
    // this.show = 'success';
    // this.showDiv = 'kycComp';
    // this.dismissmodal()
  }


  continueWithOTP() {

    if (this.beneficiaryType !== BeneficiaryType.Director_Promoter) {
      this.form.relationship.setValidators(null);
      this.form.relationship.updateValueAndValidity();
    }

    if (this.form.CKYCMobileNo.value == "") {
      this.beneficiaryForm.get('CKYCMobileNo').setErrors({ otpRequired: true });
      this.beneficiaryForm.markAsTouched();
      return
    }
    if (this.beneficiaryForm.invalid) return;


    if (this.form.relationship.value === BeneficiaryType.Director || this.beneficiaryType === BeneficiaryType.Karta) {
      if (this.form.pan.value.charAt(3).toUpperCase() !== 'P') {
        this.offlineModelView(ErrorMessage.IndividualError, true)
        return;
      }
    }

    let dob = "";
    if (this.form.dob.value !== "") {
      let newDate = new Date(this.form.dob.value);
      newDate.setDate(newDate.getDate())
      let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
      dob = formatedDate;
    }

    let data = {
      applicationUuid: this.application.investmentID,
      pan: this.form.pan.value,
      dob: dob,
      typeOfInvestor: this.form.pan.value.charAt(3).toUpperCase() !== 'P' ? "Non-Individual" : "Individual",
      type: this.beneficiaryType,
      relationship: this.form.relationship.value !== '' ? this.form.relationship.value : this.beneficiaryType,
      ckycStatus: " ",
      ckycDetail: '',
      mobileNo: this.form.CKYCMobileNo.value
    };
    if (this.form.relationship.value) {
      data.type = this.form.relationship.value
    }
    this.showLoader = true;
    this.requestID = this.commonService.generateRequestId();
    let reqBody;
    reqBody = {
      PAN: this.form.pan.value,
      DOB: dob,
      mobile: this.form.CKYCMobileNo.value,
      requestId: this.requestID
    }

    this.applicationService.getCKYC(reqBody).subscribe(
      async (res: any) => {
        if (res.message.includes('OTP has been sent to the registered mobile number')) {

          this.dismissModal()
          const modal = await this.modalController.create({
            component: OTPValidationModal,
            backdropDismiss: false,
            cssClass: 'myCustomClass',
            componentProps: {
              mobileNumber: this.form.CKYCMobileNo.value,
              pan: this.form.pan.value,
              dob: dob,
              requestId: this.requestID,
              onVerified: async (res: any) => {
                data.ckycStatus = "SUCCESS";
                data.ckycDetail = JSON.stringify(res.value.data)
                this.beneficiaryService.createBeneficiary(data).subscribe(
                  async (res: any) => {
                    let data = JSON.parse(res.data)
                    data.investmentId = this.application.investmentID
                    if (data.ckycCheck === 1) {
                      this.otpVerified(data)

                    } else {
                      this.dismissModal();

                      if (this.form.pan.value.charAt(3).toUpperCase() !== 'P') {
                        this.investmentService.deleteInvestment(this.application.investmentID, data.investorId, false, true, BeneficiaryTypeNo.Beneficiary).subscribe(
                          (res: any) => {
                            this.offlineModelView(ErrorMessage.NonKYCError, false)
                          },
                        );
                        return;
                      }
                    }
                  },
                  async (err) => {
                    this.showLoader = false;
                    const toast = await this.toastController.create({
                      message: err.error.message,
                      duration: 2000,
                    });
                    toast.present();
                  }
                )
              }
            }
          });
          await modal.present();
        }
        else if (res.value.status === 'ERROR') {
          this.showLoader = false
          const errorMsg: string = res.message || '';
          if (errorMsg.toLowerCase().includes('date of birth')) {
            this.beneficiaryForm.get('dob').setErrors({ dobNotMatched: true })
            this.beneficiaryForm.markAllAsTouched();
          }
          if (errorMsg.toLowerCase().includes('mobile')) {
            this.beneficiaryForm.get('CKYCMobileNo').setErrors({ mobileNotMatched: true })
            this.beneficiaryForm.markAllAsTouched();
          }
          if (errorMsg.toLowerCase().includes('no record found')) {
            this.beneficiaryForm.get('pan').setErrors({ noRecordFound: true })
            this.beneficiaryForm.markAllAsTouched();
          }
          if (errorMsg.toLowerCase().includes('please try again')) {
            this.beneficiaryForm.get('pan').setErrors({ serverError: true })
            this.beneficiaryForm.markAllAsTouched();
          }
          return;
        }
      }
    )
  }

  continueWithoutOTP() {

    this.beneficiaryForm.get('CKYCMobileNo').setErrors(null)

    if (this.beneficiaryType !== BeneficiaryType.Director_Promoter) {
      this.form.relationship.setValidators(null);
      this.form.relationship.updateValueAndValidity();
    }
    if (this.beneficiaryForm.invalid) return;


    if (this.form.relationship.value === BeneficiaryType.Director || this.beneficiaryType === BeneficiaryType.Karta) {
      if (this.form.pan.value.charAt(3).toUpperCase() !== 'P') {
        this.offlineModelView(ErrorMessage.IndividualError, true)
        return;
      }
    }

    let dob = "";
    if (this.form.dob.value !== "") {
      let newDate = new Date(this.form.dob.value);
      newDate.setDate(newDate.getDate())
      let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
      dob = formatedDate;
    }

    let ckycNumberdata = ""

    if (this.ckycSearchData !== null) {
      ckycNumberdata = this.ckycSearchData
    } else {
      ckycNumberdata = ""
    }

    let data = {
      applicationUuid: this.application.investmentID,
      pan: this.form.pan.value,
      dob: dob,
      typeOfInvestor: this.form.pan.value.charAt(3).toUpperCase() !== 'P' ? "Non-Individual" : "Individual",
      type: this.beneficiaryType,
      relationship: this.form.relationship.value !== '' ? this.form.relationship.value : this.beneficiaryType,
      ckycStatus: "error",
      ckycDetail: '',
      mobileNo: this.form.CKYCMobileNo.value,
      ckycNumber: ckycNumberdata
    };

    if (this.form.relationship.value) {
      data.type = this.form.relationship.value
    }
    this.showLoader = true;
    this.headerText = '';
    this.messageText = '';
    this.beneficiaryService.createBeneficiary(data).subscribe(
      async (res: any) => {
        if (res.success == true) {
          let data = JSON.parse(res.data)
          if (data.ckycCheck === 1) {
            await this.modalController.dismiss({
              data: data.investorId,
            });
            this.showLoader = false;

            this.commonService.encrypt(data.investorId).subscribe((res: any) => {

              let investorId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
              this.commonService.encrypt(this.application.investmentID).subscribe((res: any) => {
                let investmentId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
                window.location.href = '/application/applicant-kyc-details/' + investorId + "/" + investmentId;
              });

            });
          }
          else {
            this.dismissModal();

            if (this.form.pan.value.charAt(3).toUpperCase() !== 'P') {
              console.log("this.form.pan.value.charAt(3).toUpperCase()")
              this.investmentService.deleteInvestment(this.application.investmentID, data.investorId, false, true, BeneficiaryTypeNo.Beneficiary).subscribe(
                (res: any) => {

                  this.offlineModelView(ErrorMessage.NonKYCError, false)
                },
              );
              return;
            }

            this.commonService.encrypt(data.investorId).subscribe((res: any) => {

              let investorId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');

              this.commonService.encrypt(this.application.investmentID).subscribe((res: any) => {

                let investmentId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');

                window.location.href = '/application/applicant-kyc-details/' + investorId + "/" + investmentId;

              });

            });
            // await this.modalController.dismiss({                  
          }
        } else {
          this.dismissModal();
          const modal = await this.modalController.create({
            component: OopsModalComponent,
            backdropDismiss: false,
            cssClass: 'my-custom-class',
          });
          await modal.present();
          modal.onDidDismiss().then((event) => { });

          this.showLoader = false;
          const toast = await this.toastController.create({
            message: res.message,
            duration: 2000,
          });
          toast.present();
        }
      },
      async (err) => {
        this.showLoader = false;
        const toast = await this.toastController.create({
          message: err.error.message,
          duration: 2000,
        });
        toast.present();
      }
    )
  }
}
